import { render, staticRenderFns } from "./ContentCanvas.vue?vue&type=template&id=f20f2fa0&scoped=true"
import script from "./ContentCanvas.vue?vue&type=script&lang=js"
export * from "./ContentCanvas.vue?vue&type=script&lang=js"
import style0 from "./ContentCanvas.vue?vue&type=style&index=0&id=f20f2fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20f2fa0",
  null
  
)

export default component.exports